/** FormDialog sizing, kept pure so the default stays covered by a test (POS-I266). */
export type FormDialogSize = 'default' | 'large' | 'full';

export interface FormDialogLayout {
  style: { width: string };
  breakpoints: Record<string, string> | undefined;
  sizeClassName: string | undefined;
}

export const DEFAULT_FORM_DIALOG_WIDTH = '34rem';

export function formDialogLayout(size: FormDialogSize = 'default', width: string = DEFAULT_FORM_DIALOG_WIDTH): FormDialogLayout {
  // POS-I277: opt-in mid size for long, sectioned forms (min(1100px, 94vw), up to 90vh; header and footer pinned, body scrolls).
  if (size === 'large') return { style: { width: 'min(1100px, 94vw)' }, breakpoints: undefined, sizeClassName: 'dialog-large' };
  if (size === 'full') return { style: { width: '96vw' }, breakpoints: undefined, sizeClassName: 'dialog-full' };
  return { style: { width }, breakpoints: { '960px': '75vw', '640px': '95vw' }, sizeClassName: undefined };
}
